import * as Toast from '@radix-ui/react-toast';
import styled, { keyframes } from 'styled-components';

export const ToastRoot = styled(Toast.Root)`
  --viewport-padding: 12px;
  display: grid;
  grid-template-areas: 'title action' 'description action';
  grid-template-columns: auto max-content;
  column-gap: 0;
  align-items: center;
  cursor: pointer;
  padding: 12px;
  border-radius: 8px;
  background: rgba(40, 48, 128, 0.9);
  box-shadow: 0px 8px 48px 24px #161639;
  backdrop-filter: blur(9px);
  position: relative;
  overflow: hidden;
  padding-right: 24px;

  ${({ $hasAction }) =>
    $hasAction &&
    `
    background-image:url('/images/icons/carret-right-notify.svg');
    background-repeat: no-repeat;
    background-position: right 12px center;
  `}

  &[data-state='open'] {
    /* animation: slideIn 150ms cubic-bezier(0.16, 1, 0.3, 1); */
  }

  &[data-state='closed'] {
    animation: hide 100ms ease-in;
  }

  &[data-swipe='move'] {
    transform: translateX(var(--radix-toast-swipe-move-x));
  }

  &[data-swipe='cancel'] {
    transform: translateX(0);
    transition: transform 200ms ease-out;
  }

  &[data-swipe='end'] {
    animation: swipeOut 100ms ease-out;
  }

  @keyframes hide {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  @keyframes slideIn {
    from {
      transform: translateY(calc(-100% - var(--viewport-padding)));
    }
    to {
      transform: translateY(0);
    }
  }

  @keyframes swipeOut {
    from {
      transform: translateX(var(--radix-toast-swipe-end-x));
    }
    to {
      transform: translateX(calc(100% + var(--viewport-padding)));
    }
  }
`;

export const ToastViewport = styled(Toast.Viewport)`
  position: fixed;
  top: 0;
  right: 50%;
  transform: translate(50%, 0%);
  display: flex;
  flex-direction: column;
  padding: 24px 0;
  gap: 10px;
  width: 320px;
  max-width: 100vw;
  margin: 0;
  list-style: none;
  z-index: 2147483647;
  outline: none;

  //   $---{({ $isLoyalty }) =>
  //     $isLoyalty &&
  //     ---\`
  //       padding: 32px 0;
  //       cursor: pointer;
  // &:before {
  //     content:'';
  //     background-image:url(/images/background/loyalty-toast-top.svg);
  //     position:absolute;
  //     width:172px;
  //     height:10px;
  //     top:28px;
  //     z-index:1000;
  //     left:50%;
  //     transform:translateX(-51%);
  //     }

  //     &:after {
  //     content:'';
  //     background-image:url(/images/background/loyalty-toast-bottom.svg);
  //     position:absolute;
  //     width:112px;
  //     height:10px;
  //     top:104px;
  //     z-index:1000;
  //     left:50%;
  //     transform:translateX(-51%);
  //     }

  //   ---\`}
`;

export const ToastClose = styled(Toast.Close)`
  background-color: transparent;
  border: none;
  padding: 0;
  display: grid;
  place-items: center;
  cursor: pointer;
`;

export const IconWrapper = styled.div`
  grid-area: icon;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;

  ${({ $status }) =>
    $status === 'success' &&
    `
    border-radius: 100px;
    background: var(--Green, #08AD5E);
    box-shadow: 0px 0px 80px 20px #08AD5E, 0px 1px 1px 0px rgba(239, 241, 243, 0.06) inset;  `}
  ${({ $status }) =>
    $status === 'standard' &&
    `
    border-radius: 100px;
    background: var(--1-f-78-ff, #131315);
    box-shadow: 0px 1px 1px 0px rgba(239, 241, 243, 0.06) inset, 0px 0px 80px 20px #131315;  `}
  ${({ $status }) =>
    $status === 'error' &&
    `
    border-radius: 100px;
    background: var(--Red, #DA4444);
    box-shadow: 0px 0px 80px 20px #FF3B30, 0px 1px 1px 0px rgba(239, 241, 243, 0.06) inset;  `}
`;

// export const LoyaltyContainer = styled.div`
//   width: 100%;
//   height: 320px;
//   position: fixed;
//   z-index: 1000;
//   top: 0;
//   background-image: url('/images/background/loyalty-bg-notify.png');
//   background-repeat: no-repeat;
//   background-size: contain;
// `;

export const LoyaltyLevel = styled.div`
  border-radius: 16px;
  border: 2px solid #fff;
  background: var(--1-f-78-ff, #131315);
  padding: 4px 12px;
  position: absolute;
  left: 128px;
  z-index: 1000;
  top: 16px;
`;
